// extracted by mini-css-extract-plugin
export default {"formHeaderPlainStyle":"FormElementsBlock_formHeaderPlainStyle__4yKPT subtitle--m"};